export default {
  methods: {
    getProfile() {
      return this.axios.get('/api/v1/profile');
    },
    getImage() {
      return this.axios.get('/api/v1/profile/image', { responseType: 'blob' });
    },
    postPassword(body) {
      return this.axios.post('/api/v1/profile/change-password', body);
    },
    postEmail(body) {
      return this.axios.post('/api/v1/profile/change-email', body);
    },
    putProfile(body) {
      return this.axios.put('/api/v1/profile', body);
    },
    putImage(file) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('name', file.name);
      formData.append('type', file.type);
      formData.append('size', file.size);
      return this.axios.post('/api/v1/profile/image', formData);
    },
    deleteAccount() {
      return this.axios.post('/api/v1/users/delete-user', {});
    },
  },
};
